import React from "react";
import { motion } from "framer-motion";
import { FEATURED_DONUTS, ORDER_LINKS } from "../data/menu";
import { ArrowUpRight } from "lucide-react";

export const FeaturedDonuts = () => {
  return (
    <section id="menu" className="relative py-20 sm:py-32 bg-[#FFFDFB]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-10 sm:mb-14">
          <div>
            <p className="font-script text-[#FF6392] text-3xl -rotate-2 inline-block">the favorites,</p>
            <h2 className="font-serif-display text-3xl sm:text-5xl lg:text-6xl text-[#2D2327] tracking-tight mt-2">
              Donuts worth the
              <span className="italic text-[#FF6392]"> drive.</span>
            </h2>
          </div>
          <a
            href={ORDER_LINKS.doordash}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="featured-see-full-menu"
            className="inline-flex items-center gap-2 text-[#2D2327] font-semibold border-b-2 border-[#FF6392] pb-1 hover:text-[#FF6392] transition-colors w-fit"
          >
            See the full menu <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {FEATURED_DONUTS.map((d, i) => (
            <motion.article
              key={d.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
              data-testid={`donut-card-${d.name.toLowerCase().replace(/\s+/g, "-")}`}
              className={`relative overflow-hidden rounded-[2rem] ${d.color} p-5 sm:p-6 lift border border-white/60 shadow-[0_6px_30px_rgba(0,0,0,0.04)]`}
            >
              <div className="flex items-start justify-between">
                <span className={`text-[11px] uppercase tracking-[0.22em] font-semibold ${d.accent}`}>
                  {d.tag}
                </span>
                <span className="font-serif-display text-2xl text-[#2D2327]">{d.price}</span>
              </div>

              <div className="mt-5 aspect-[4/3] w-full rounded-2xl overflow-hidden bg-white">
                <img src={d.image} alt={d.name} loading="lazy" className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>

              <h3 className="mt-5 font-serif-display text-xl sm:text-3xl text-[#2D2327]">{d.name}</h3>
              <p className="mt-2 text-sm sm:text-base text-[#4A3F44]/90 leading-relaxed">{d.desc}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedDonuts;
